import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { ComponentsComponent } from './components/components.component'
import { LoginComponent } from './components/login/login.component'
import { RegisterComponent } from './components/register/register.component'
import { PageComponent } from './page/page.component'
import { AuthGaurd } from './shared/auth-gaurd.service'
import { PaybackComponent } from './components/payback/payback.component'

var routes: Routes = [
  {
    path: '',
    redirectTo: 'account/login', // base/index, account/login
    pathMatch: 'full'
  },
  {
    path: 'account',
    redirectTo: 'account/login',
    pathMatch: 'full'
  },
  {
    path: 'base',
    redirectTo: 'base/index',
    pathMatch: 'full'
  },
  {
    path: 'home',
    redirectTo: 'home/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'account', component: ComponentsComponent, children: [
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      //{ path: 'logout', component: LogoutComponent },
      //{ path: 'recovery', component: RecoveryComponent },
    ]
  },
  {
    path: 'payment', component: ComponentsComponent, children: [
      { path: 'payback', component: PaybackComponent },
    ]
  },
  {
    path: 'base', children:
      [
        { path: ':id', component: PageComponent }, // index
        { path: 'page/:id', component: PageComponent } // id => number(page_id) or string(news, gallery, ...)
      ]
  },
  {
    path: 'home', children:
      [
        { path: ':id', canActivateChild: [AuthGaurd], component: PageComponent },
        //{ path: 'page/:id', canActivateChild: [AuthGaurd], component: PageComponent }  // id => number(page_id) or string(news, gallery, ...)
      ]
  },
  {
    path: 'filer',
    children:
      [
        {
          path: ':tit',
          redirectTo: 'http://localhost:2021/filer/logo'
        }, // index

        //{ path: 'page/:id', component: PageComponent } // id => number(page_id) or string(news, gallery, ...)
      ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }